import { Component, OnInit, Output, EventEmitter, Input, ViewChildren, QueryList } from '@angular/core';
import {
  IndPhrase,
  CatDoc,
  IndImage,
  IndElement,
  CatDocStateTagEnum,
  IndPhraseSearchParams,
  ReferenceDocument,
} from 'src/app/shared/models/cat.model';
import { NgRedux } from '@redux/redux-compatibility.service';
import { AppState, actionsList } from 'src/app/shared/redux/store';
import { CatService } from 'src/app/shared/services/cat.service';
import { Unsubscribe } from 'redux';
import { Subject, Subscription, Observable, EMPTY, timer, merge, throwError } from 'rxjs';
import { AuthService } from 'src/app/shared/services/auth.service';
import { SharedService } from 'src/app/shared/services/shared.service';
import { TranslateService } from '@ngx-translate/core';
import { PhrasesCacheObject } from '@shared/models/phrases-cache-object.model';
import { takeUntil, switchMap, filter, expand, catchError, map, scan, delay, retryWhen } from 'rxjs/operators';
import { CatDocPhraseTileComponent } from '../cat-doc-phrase-tile/cat-doc-phrase-tile.component';
import { SearchRunStatusEnum } from '@shared/models/common';
import { ParentTileChildrenSelectionResponse } from '@shared/models/parent-tile-children-selection-response.model';
import { IntegrationService } from '@shared/services/integration.service';
import { DocumentPositionSyncService } from '@shared/services/document-position-sync.service';

@Component({
    selector: 'cat-doc-phrase-list',
    templateUrl: './cat-doc-phrase-list.component.html',
    styleUrls: ['./cat-doc-phrase-list.component.scss'],
    standalone: false
})
export class CatDocPhraseListComponent implements OnInit {
  @Input() editable: boolean = true;
  @Input() main: boolean = true;
  @Input() stateTag: CatDocStateTagEnum = CatDocStateTagEnum.PRIME;
  @Input() sortByPagePosition: boolean = false;
  @Input() sortImagesInPositionSync: boolean = false;

  loading: boolean;
  @Output() onTogglePhraseView = new EventEmitter<IndElement>();
  @Output() onHidePhrase = new EventEmitter<IndElement>();
  @Output() onShowPhrase = new EventEmitter<IndElement>();
  @Output() loadedMoreItems = new EventEmitter();

  private cancelPreviousSearch$ = new Subject<void>();
  private onDestroy$ = new Subject();

  @ViewChildren('phraseTiles') phraseTiles!: QueryList<CatDocPhraseTileComponent>;
  @ViewChildren('imageTiles') imageTiles!: QueryList<CatDocPhraseTileComponent>;


  displayPageNum: boolean;
  un: Unsubscribe;
  getDataSub: Subscription;
  getDataPhrasesSub: Subscription;
  searchStatusTimer: any;
  searchStatusIntervalSec: number = 2;
  sub: Subscription;
  isFilterActive: boolean = false;
  referenceDocuments: ReferenceDocument[] = [];

  private phrasesCache: Map<number, PhrasesCacheObject> = new Map();
  
  get phraseList(): IndPhrase[] {
    const phrases = this.stateTag == CatDocStateTagEnum.PRIME
      ? this.ngRedux.getState().curCatDocStatePrime.indDocPhrases
      : this.ngRedux.getState().curCatDocStateSec.indDocPhrases;
    return this.sortByPagePosition
      ? this.documentPositionSyncService.sortByPagePosition(phrases)
      : phrases;
  }

  get imageList(): IndImage[] {
    const images = this.stateTag == CatDocStateTagEnum.PRIME
      ? this.ngRedux.getState().curCatDocStatePrime.indDocImages
      : this.ngRedux.getState().curCatDocStateSec.indDocImages;
    if (this.sortByPagePosition && this.sortImagesInPositionSync) {
      return [];
    }
    return this.sortByPagePosition
      ? this.documentPositionSyncService.sortByPagePosition(images)
      : images;
  }

  private get storedImages(): IndImage[] {
    return this.stateTag == CatDocStateTagEnum.PRIME
      ? this.ngRedux.getState().curCatDocStatePrime.indDocImages
      : this.ngRedux.getState().curCatDocStateSec.indDocImages;
  }

  get displayedElements(): IndElement[] {
    const elements = this.sortByPagePosition && this.sortImagesInPositionSync
      ? [...this.phraseList, ...this.storedImages]
      : this.phraseList;
    return this.sortByPagePosition
      ? this.documentPositionSyncService.sortByPagePosition(elements)
      : elements;
  }

  get curCatDocPageNum(): number {
    return this.stateTag == CatDocStateTagEnum.PRIME
      ? this.ngRedux.getState().curCatDocStatePrime.curCatDocPageNum
      : this.ngRedux.getState().curCatDocStateSec.curCatDocPageNum;
  }

  get curCatDoc(): CatDoc {
    return this.stateTag == CatDocStateTagEnum.PRIME
      ? this.ngRedux.getState().curCatDocStatePrime.curCatDoc
      : this.ngRedux.getState().curCatDocStateSec.curCatDoc;
  }

  get phraseSearchParams(): IndPhraseSearchParams {
    return this.stateTag == CatDocStateTagEnum.PRIME
      ? this.ngRedux.getState().curCatDocStatePrime.catPhrasesSearchParams
      : this.ngRedux.getState().curCatDocStateSec.catPhrasesSearchParams;
  }

  get addToStore(): boolean {
    return this.ngRedux.getState().addToStore;
  }
  set addToStore(value: boolean) {
    this.ngRedux.getState().addToStore = value;
  }
  constructor(
    private ngRedux: NgRedux<AppState>,
    private catService: CatService,
    private authService: AuthService,
    private sharedService: SharedService,
    private translateService: TranslateService,
    private integrationService: IntegrationService,
    private documentPositionSyncService: DocumentPositionSyncService
  ) {
    this.un = this.ngRedux.subscribe(() => {
      const appState = this.ngRedux.getState();
      switch (appState._currentAction) {
        case actionsList.FILTER_CAT_DOC_PHRASES:
          if (appState._currentActionCatDocStateTag != this.stateTag) return;
          ;
          this.displayPageNum = true;
          this.isFilterActive = true;
          this.getData(null, false);
          this.addToStore = false;
          break;
        case actionsList.SELECT_CAT_DOC_PAGE_NUM:
          if (appState._currentActionCatDocStateTag != this.stateTag) return;
          this.isFilterActive = false;
          this.displayPageNum = false;
          this.getData(this.curCatDocPageNum);
          break;
        case actionsList.RELOAD_CAT_DOC_PAGE_REQ:
          if (this.isFilterActive) {
            //SET FIRST PAGE
            this.displayPageNum = true;
            this.phraseSearchParams.currLoadedIndPhraseSearchResultNum = 0;
            this.ngRedux.getState().currLoadedIndPhrasesSearchResultNum = 0;
            this.addToStore = false;
            this.getData(null, false);
          } else {
            this.displayPageNum = false;
            this.getData(this.curCatDocPageNum, false);
          }
          break;
        case actionsList.INVALIDATE_PDF_CACHE:
          this.phrasesCache = new Map();
          break;
      }
    });
  }

  isMine(currentActionData: any) {
    return (
      (currentActionData.main && this.main) ||
      (!currentActionData.main && !this.main)
    );
  }

  ngOnInit(): void {

    
    this.getData(this.curCatDocPageNum);
    if (this.ngRedux.getState().curCat != undefined) {
        
      this.catService.getCatPhraseTypes(this.ngRedux.getState().curCat.catId).subscribe();
    }
  }



  ngOnDestroy(): void {
    if (this.un) {
      this.un();
    }
    this.sub?.unsubscribe();
    this.onDestroy$.next();
  }

  getData(pageNum: number, useCache = true) {
    // Cancel any ongoing requests
    this.cancelPreviousSearch$.next(); // Emit a value to cancel the previous flow
    this.cancelPreviousSearch$ = new Subject<void>(); // Reinitialize the Subject for the new flow

    
    if (!this.addToStore) {
      
      this.ngRedux.dispatch({
            type: actionsList.RUN_IND_PHRASES_SEARCH,
            catDocSTateTag: this.stateTag,
          });
    
    // Dispatch loading action
    this.ngRedux.dispatch({
      type: actionsList.UPD_DOC_PAGE_LOADING,
      data: true,
    });
    this.loading = true;

  }

    // Check if the next page is in the cache
    let nextPageNum;
    let isCurrentPageCached = false
    let isNextPageCached = false; 
    if (useCache) {
      
      // Check if next page is in the cache
      nextPageNum = pageNum + 1;
      isNextPageCached = this.phrasesCache.has(nextPageNum);

      // Check if the current page is in the cache
       isCurrentPageCached = this.phrasesCache.has(pageNum);
      if (isCurrentPageCached) {
        this.setPageFromCache(pageNum);
        this.catService.searchFinished$.next(true);
      }
      // If both pages are cached, exit early
      if (isCurrentPageCached && isNextPageCached) {

        return;
      }
  }

    // Prepare observables for current and next page
    
    const currentPageRequest$ = isCurrentPageCached
      ? EMPTY // Skip request if current page is cached
      : this.catService.getIndPhrasesLight(this.curCatDoc.docId, pageNum, this.phraseSearchParams, this.stateTag)
        .pipe(
          map(data => {
            return {pageNum, data};
          }),
          catchError((err) => {
            // Handle the error locally and return an empty observable
            console.error(`Error fetching data for current page (${pageNum}):`, err);
              this.loading = false;
              this.ngRedux.dispatch({
                type: actionsList.UPD_DOC_PAGE_LOADING,
                data: false,
              });
              this.sharedService.showInfoMessage({
                messageKey: 'translate.alert.searchError',
                infoType: 'error',
              });
              //enable button for loading more results
              this.loadedMoreItems.emit();
            
            return EMPTY; // Prevent the error from propagating to the merge stream
          })
        );

    const nextPageRequest$ = EMPTY;

    // Merge the requests so they emit independently
    this.getDataSub = merge(currentPageRequest$, nextPageRequest$)
      .pipe(takeUntil(this.cancelPreviousSearch$)) // Cancel both requests if a new request starts
      .subscribe(
        (response: { pageNum: number; data: PhrasesCacheObject }) => {
          // Save data to cache
          if (response.pageNum !== null) {
            
              this.phrasesCache.set(response.pageNum, response.data);
          }
          // Handle current page response
          if (response.pageNum != null && response.pageNum === this.curCatDocPageNum) {
            
            this.setPhrasesToStore(response.data);
            this.catService.searchFinished$.next(true);
          }

          if (response.pageNum == null) {

            this.addPhrasesToStore(response.data);
            this.catService.searchFinished$.next(true);
            //enable button for loading more results
            this.loadedMoreItems.emit();
          }

          this.integrationService.getAvailableReferenceDocs(this.curCatDoc.catVersionId)
            .subscribe((docs) => {
              this.referenceDocuments = docs;
            });
        },
        (err) => {
          console.error('Error fetching data:', err);
        }
      );
  }

  addPhrasesToStore(phrasesCacheObject: PhrasesCacheObject) {
    this.ngRedux.dispatch({
      type: actionsList.ADD_CAT_DOC_PAGE_LINES,
      data: phrasesCacheObject.pageLines,
      reply: phrasesCacheObject.reply,
      catDocSTateTag: phrasesCacheObject.catDocSTateTag
    });
    this.ngRedux.dispatch({
      type: actionsList.ADD_IND_DOC_IMAGES,
      data: phrasesCacheObject.images,
      reply: phrasesCacheObject.reply,
      catDocSTateTag: phrasesCacheObject.catDocSTateTag
    });
    this.ngRedux.dispatch({
      type: actionsList.ADD_BOUNDING_BOXES,
      data: phrasesCacheObject.boundingBoxes,
      reply: phrasesCacheObject.reply,
      catDocSTateTag: phrasesCacheObject.catDocSTateTag
    });
    this.ngRedux.dispatch({
      type: actionsList.ADD_IND_DOC_PHRASES,
      data: phrasesCacheObject.indPhrases,
      reply: phrasesCacheObject.reply,
      catDocSTateTag: phrasesCacheObject.catDocSTateTag
    });
    this.loading = false;
    this.ngRedux.dispatch({
      type: actionsList.UPD_DOC_PAGE_LOADING,
      data: false,
    }); 

  }

  setPhrasesToStore(phrasesCacheObject: PhrasesCacheObject) {
    this.ngRedux.dispatch({
      type: actionsList.GET_CAT_DOC_PAGE_LINES,
      data: phrasesCacheObject.pageLines,
      reply: phrasesCacheObject.reply,
      catDocSTateTag: phrasesCacheObject.catDocSTateTag
    });
    this.ngRedux.dispatch({
      type: actionsList.GET_IND_DOC_IMAGES,
      data: phrasesCacheObject.images,
      reply: phrasesCacheObject.reply,
      catDocSTateTag: phrasesCacheObject.catDocSTateTag
    });
    this.ngRedux.dispatch({
      type: actionsList.GET_BOUNDING_BOXES,
      data: phrasesCacheObject.boundingBoxes,
      reply: phrasesCacheObject.reply,
      catDocSTateTag: phrasesCacheObject.catDocSTateTag
    });

    this.ngRedux.dispatch({
      type: actionsList.GET_IND_DOC_PHRASES,
      data: phrasesCacheObject.indPhrases,
      reply: phrasesCacheObject.reply,
      catDocSTateTag: phrasesCacheObject.catDocSTateTag
    });

    this.loading = false;
    this.ngRedux.dispatch({
      type: actionsList.UPD_DOC_PAGE_LOADING,
      data: false,
    });
  }

  setPageFromCache(pageNum: number) {
    
      const phrasesCacheObject = this.phrasesCache.get(pageNum);
      this.setPhrasesToStore(phrasesCacheObject);
    
  }

  pullSearchStatus(searchId: number): Observable<SearchRunStatusEnum> {
    return this.authService.getSearchStatus(searchId).pipe(
      expand((status) => {
        if (status === SearchRunStatusEnum.FINISHED || status === SearchRunStatusEnum.ERROR) {
          return EMPTY; // Stop polling
        }
        return timer(this.searchStatusIntervalSec * 1000).pipe(
          switchMap(() =>
            this.authService.getSearchStatus(searchId).pipe(
              catchError((err) => {
                console.error('Error during polling:', err);
                throw err; // Propagate the error to retry logic
              })
            )
          )
        );
      }),
      retryWhen((errors) =>
        errors.pipe(
          scan((retryCount, err) => {
            if (retryCount >= 2) {
              console.error('Error occurred 3 times during polling:', err);
              throw err; // Propagate the error to the parent observable
            }
            console.warn(`Retrying polling (${retryCount + 1}/3)...`);
            return retryCount + 1;
          }, 0),
          delay(this.searchStatusIntervalSec * 1000) // Delay between retries
        )
      ),
      takeUntil(this.cancelPreviousSearch$) // Stop polling if a new request starts
    );
  }

  onTogglePhraseViewClicked(element: IndElement) {
    this.onTogglePhraseView.emit(element);
  }

  onGoToPhrasePage(element: IndElement) {
    this.onTogglePhraseView.emit(element);
  }

  onMouseEnter(element: IndElement) {
    this.onShowPhrase.emit(element);
  }

  onMouseLeave(element: IndElement) {
    if (!element.viewSw) this.onHidePhrase.emit(element);
  }

  scrollToElement(element: IndElement): boolean {
    const tile = [
      ...this.phraseTiles.toArray(),
      ...this.imageTiles.toArray(),
    ].find(item => item.element === element);
    if (!tile) {
      return false;
    }

    tile.scrollIntoView();
    return true;
  }

  scrollToFirstElementOnPage(pageNum: number): boolean {
    const firstElement = this.displayedElements
      .find(element => element.pageNum === pageNum);
    return firstElement ? this.scrollToElement(firstElement) : false;
  }

  get isSearchActive() {
    let searchParams = this.phraseSearchParams;
    return searchParams && 
      (searchParams.phrase 
        || searchParams.phraseStatus 
        || searchParams.matchStatus 
        || searchParams.contentType 
        || searchParams.matchType 
        || (searchParams.subTypeList && searchParams.subTypeList.length > 0));
  }

  reloadData() {
    this.getData(this.curCatDocPageNum, false);
  }
  hasPrevPhrase(index: number) {
    
    return index != 0;
  }
  hasPrevImage(index: number) {
  
    return index != 0 || this.phraseList.length > 0;
  }

  hasNextPhrase(index: number) {
    if (this.sortByPagePosition && this.sortImagesInPositionSync) {
      return index < this.displayedElements.length - 1;
    }
    return index < (this.phraseList.length-1) || this.imageList.length > 0; 
  }
  hasNextImage(index: number) {

    return index < (this.imageList.length-1);
  }
  showPrevPhrase(editModeSw: boolean, index: number) {
    if (this.sortByPagePosition && this.sortImagesInPositionSync) {
      if (index > 0) {
        this.phraseTiles.toArray()[index - 1].openPhraseDetails(null, editModeSw);
      }
      return;
    }
    if (index != 0) {
    
      this.phraseTiles.toArray()[index - 1].openPhraseDetails(null, editModeSw);
    }
  }
  showPrevImage(editModeSw: boolean, index: number) {
    if (index != 0) {
      this.imageTiles.toArray()[index-1].openPhraseDetails(null, editModeSw);
    } else if (this.phraseList.length > 0) { 
      let phrasesArray = this.phraseTiles.toArray();  
      phrasesArray[phrasesArray.length-1].openPhraseDetails(null, editModeSw);
    }
  }
  showNextPhrase(editModeSw: boolean, index: number) {
    if (this.sortByPagePosition && this.sortImagesInPositionSync) {
      if (index < this.displayedElements.length - 1) {
        this.phraseTiles.toArray()[index + 1].openPhraseDetails(null, editModeSw);
      }
      return;
    }
    if (index < this.phraseList.length - 1) {
    
      this.phraseTiles.toArray()[index+1].openPhraseDetails(null, editModeSw);
    } else if (this.imageList.length > 0) {
      this.imageTiles.toArray()[0].openPhraseDetails(null, editModeSw);
    }
    
  }
  showNextImage(editModeSw: boolean, index: number) {
    if (index < this.imageList.length - 1) {
      this.imageTiles.toArray()[index+1].openPhraseDetails(null, editModeSw);
    }
  }

}
